import type { ReactNode } from "react";

/**
 * Every page starts here: one h1 (the thing focus lands on after a route
 * change — layouts/RouteFocus), an optional eyebrow above it, one line
 * under it, actions on the right that wrap under it on a phone. A div,
 * not a <header>: the page has one banner, the shell's.
 */
export function PageHeader({ eyebrow, title, subtitle, actions }: { eyebrow?: ReactNode; title: ReactNode; subtitle?: ReactNode; actions?: ReactNode }) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
      <div className="min-w-0">
        {eyebrow && <div className="mb-2 flex flex-wrap items-center gap-2 text-sm text-muted">{eyebrow}</div>}
        <h1 tabIndex={-1} className="text-2xl font-semibold tracking-tight text-ink sm:text-3xl">
          {title}
        </h1>
        {subtitle && <p className="mt-2 max-w-prose text-base text-muted">{subtitle}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-3">{actions}</div>}
    </div>
  );
}
